export const HomePageExplore = [
    {
        tag: 'Free',
        courses : [
            {
                heading : "Learn HTML",
                description : "This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Beginner',
                lessionNumber : 5
            },
            {
                heading : "Learn CSS",
                description : "This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Responsive Web design",
                description : "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
                level : 'Intermediate',
                lessionNumber :8
            },
        ]
    },
    {
        tag: 'New to coding',
        courses : [
            {
                heading : "HTML",
                description : "This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "CSS",
                description : "This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques",
                level : 'Beginner',
                lessionNumber : 5
            },
            {
                heading : "Responsive ",
                description : "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
                level : 'Intermediate',
                lessionNumber : 8
            },
        ]
    },
    {
        tag: 'Most popular',
        courses : [
            {
                heading : "Java",
                description : "Throughout the course, students will learn the fundamentals of Java syntax, data types, control structures, object-oriented programming principles, and more. Hands-on exercises and projects will reinforce learning, allowing students to gain practical experience in writing Java code and solving real-world problems.",
                level : 'Advance',
                lessionNumber : 20
            },
            {
                heading : "Python",
                description : "Throughout the course, participants will delve into the core concepts of Python programming, gaining proficiency in writing Python code for a wide range of applications. Hands-on exercises and projects will reinforce learning, allowing students to apply Python concepts to real-world scenarios.",
                level : 'Beginner',
                lessionNumber : 10
            },
            {
                heading : "SCSS",
                description : "Throughout the course, students will explore the advanced features of SCSS and learn how to leverage them effectively in web development projects. Through a combination of lectures, demonstrations, and hands-on exercises, participants will gain a deep understanding of SCSS syntax, best practices, and techniques for optimizing stylesheet organization and performance.",
                level : 'Beginner',
                lessionNumber : 8
            },
        ]
    },
    {
        tag: 'Skills paths',
        courses : [
            {
                heading : "Flask",
                description : "Throughout the course, participants will learn how to leverage Flask to create dynamic and interactive web applications, from simple websites to more complex projects. Through a combination of lectures, hands-on exercises, and practical projects, students will gain a solid understanding of Flask's core concepts and best practices in web development..",
                level : 'Beginner',
                lessionNumber : 7
            },
            {
                heading : "Django",
                description : "Throughout the course, students will dive into Django's core components and learn how to utilize them effectively in web development projects. Through a blend of theoretical concepts, hands-on exercises, and real-world projects, participants will gain proficiency in developing dynamic and feature-rich web applications with Django.",
                level : 'Intermediate',
                lessionNumber : 10
            },
            {
                heading : "Fast API",
                description : "Throughout the course, students will delve into the core features of FastAPI and learn how to leverage its capabilities to create robust APIs for a wide range of applications. Through a combination of lectures, hands-on exercises, and practical projects, participants will gain proficiency in developing APIs with FastAPI, taking advantage of its asynchronous capabilities and automatic documentation generation.",
                level : 'Beginner',
                lessionNumber : 4
            },
        ]
    },
    {
        tag: 'Career paths',
        courses : [
            {
                heading : "Next.js",
                description : "Throughout the course, participants will explore the key features of Next.js and learn how to leverage them effectively in web development projects. From server-side rendering to static site generation and client-side routing, students will gain hands-on experience in building dynamic and interactive web applications using Next.js.",
                level : 'Beginner',
                lessionNumber : 5
            },
            {
                heading : "PHP",
                description : "Throughout the course, students will explore the fundamental concepts of PHP programming and learn how to leverage its features to create dynamic and interactive websites. From basic syntax to advanced topics such as database integration and user authentication, participants will gain hands-on experience through practical exercises and real-world projects.",
                level : 'Advance',
                lessionNumber : 25
            },
            {
                heading : "MySql",
                description : "Throughout the course, students will explore the core concepts of MySQL database management, learning how to design, implement, and maintain efficient databases. From creating tables and managing data to performing complex queries and optimizing database performance, participants will gain practical experience through hands-on exercises and real-world projects.",
                level : 'Advance',
                lessionNumber : 30
            },
        ]
    },
]